import './styles.scss';

import { Button, Link, Message, Stack } from '@kolonialno/lama';
import { BrowserRouter as Router } from 'react-router';

import Container from './components/Container';
import Routes from './routing';
import {
    type AuthenticationContext,
    useAuthenticationContext,
} from './utils/context';
import { withRedirect } from './utils/redirect';

type UserAuthenticatedProps = {
    context: AuthenticationContext;
};
function UserAuthenticated({ context }: UserAuthenticatedProps) {
    const title = context.redirect
        ? undefined
        : 'You are already authenticated';

    return (
        <Container title={title}>
            {context.redirect && (
                <Message variant="danger">
                    You don&apos;t have access to this application.
                </Message>
            )}

            <Stack>
                <Button variant="primary" size="m" as="a" href="/">
                    Open application portal
                </Button>
            </Stack>

            <Link
                className="purple-text"
                as="a"
                href={withRedirect(context.logoutUrl, context.redirect)}
            >
                Log out
            </Link>
        </Container>
    );
}

function InnerApp(props: { children: React.ReactNode }) {
    const context = useAuthenticationContext();

    if (context.authenticated && !context.redirectConfirmation) {
        return <UserAuthenticated context={context} />;
    }

    return <div>{props.children}</div>;
}

function App() {
    return (
        <Router>
            <InnerApp>
                <Routes />
            </InnerApp>
        </Router>
    );
}

export default App;
